import React, { useEffect, useState } from "react";
import PaymentReportService from "../../../services/OrderingServices/PaymentReportService";
import { useParams } from "react-router-dom";
import toast from "react-hot-toast";
import BreadCrumb from "../../../Components/Common/BreadCrumb";
import { Card, CardBody, Row } from "reactstrap";
import { formatDateTime } from "../../../Components/Common/FormatDate";

const DaybookLogDetail = () => {
  const { id } = useParams();
  const [data, setData] = useState();
  const [loading, setLoading] = useState(false);
  const fetchDayLog = async () => {
    setLoading(true);
    try {
      const response = await PaymentReportService.dayBookLogDetail(id);

      setData(response || []);
    } catch (error) {
      console.error("Error fetching payment day book:", error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchDayLog();
  }, [id]);
  const breadcrumbItems = [{ title: "Back To List ", link: "/logs/day-book" }];

  return (
    <>
      <div className="page-content">
        <div class="container-fluid">
          <BreadCrumb
            pageTitle="Day Book Logs"
            title="Day Book Logs Detail"
            breadcrumbItems={breadcrumbItems}
          />
        </div>

        <Card className="shadow-sm border-0 rounded-3 mb-3">
          <CardBody className="p-4">
            <div className="d-flex align-items-center justify-content-between mb-3">
              <h5 className="mb-0 fw-semibold text-primary">
                Day Book Log Details
              </h5>
              <span className="badge bg-light text-dark px-3 py-2">
                {formatDateTime(data?.createdAt)}
              </span>
            </div>

            <div className="border-top pt-3">
              <div className="d-flex justify-content-between mb-2">
                <span className="text-muted fw-medium">Closed By:</span>
                <span className="fw-semibold text-dark">
                  {data?.createdBy || "-"}
                </span>
              </div>

              <div className="d-flex justify-content-between mb-2">
                <span className="text-muted fw-medium">Total Amount:</span>
                <span className="fw-semibold text-success">
                  {data?.totalAmount ? `Rs. ${data.totalAmount}` : "Rs 0"}
                </span>
              </div>

              {data?.remarks && (
                <div className="mt-3 p-3 bg-light rounded-3">
                  <h6 className="fw-semibold text-secondary mb-2">Remarks</h6>
                  <p className="mb-0 text-muted small">{data.remarks}</p>
                </div>
              )}
            </div>
          </CardBody>
        </Card>

        <Card className="mb-3 shadow-sm">
          <CardBody>
            <Row className="align-items-end g-2">
              <div className="d-lg-block d-none">
                <div className="table-responsive">
                  <table className="table table-bordered table-hover">
                    <thead className="table-light">
                      <tr>
                        <th style={{ width: "80px" }}>S.N</th>
                        <th>Payment Type</th>

                        <th className="text-end">Total Amount (Rs.)</th>
                      </tr>
                    </thead>
                    <tbody>
                      {data?.details?.map((item, index) => (
                        <tr key={item.id}>
                          <td>{index + 1}</td>
                          <td>{item?.paymentTypename || "-"}</td>
                          <td className="text-end">
                            {item?.amount?.toFixed(2) || 0}
                          </td>
                        </tr>
                      ))}
                    </tbody>
                  </table>
                </div>
              </div>
            </Row>
          </CardBody>
        </Card>
      </div>
    </>
  );
};

export default DaybookLogDetail;
